import cn from 'classnames';
import { Flex, Text } from 'ui';
import type { MessageDirection } from '../../../types';

type P = {
  authorName?: string;
  direction: MessageDirection;
  formattedTime?: string;
};

const ChatMessageHeader = ({ authorName, direction, formattedTime }: P) => {
  if (!authorName && !formattedTime) {
    return null;
  }

  return (
    <Flex
      className={cn('chat-message-header', {
        'chat-message-header--incoming': direction === 'incoming',
        'chat-message-header--outgoing': direction === 'outgoing',
      })}
      gap="xs"
    >
      {authorName ? (
        <Text size="small" weight="bold">
          {authorName}
        </Text>
      ) : null}
      {formattedTime ? (
        <Text size="small" weight="base">
          {formattedTime}
        </Text>
      ) : null}
    </Flex>
  );
};

export default ChatMessageHeader;
